import { AboutPage } from './pages/AboutPage';

export const aboutRoutes = [
  { path: 'about', element: <AboutPage /> },
];
